const getFilterColumns = () => {
  return [
    {
      Header: "Agent Id",
      accessor: "agent_name",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      allowReportFilter: true,
      allowReportSort: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      controlType: "multipleSelect",
      options: {
        keyField: "agentName",
        keyDescription: "fullName",
        values: [],
        url: "agentCDR/agents",
      },
    },
    {
      Header: "Agent Name",
      accessor: "full_name",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Start Date",
      accessor: "date",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      allowReportSort: true,
      allowReportColumn: true,
      allowReportFilter: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "start time",
      accessor: "time",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "time",
      allowReportColumn: false,
      allowReportFilter: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Offered",
      accessor: "offered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Answered",
      accessor: "inAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In No Answered",
      accessor: "inNoAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Talk Time",
      accessor: "inTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Avg Talk Time",
      accessor: "inAverageTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Dialed Out",
      accessor: "dialout",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Out Answered",
      accessor: "outAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out No Answered",
      accessor: "outNoAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Out Talk Time",
      accessor: "outTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Avg Talk Time",
      accessor: "outAverageTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Answered",
      accessor: "answered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total No Answered",
      accessor: "noanswered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Ring Time",
      accessor: "ring_duration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Talk Time",
      accessor: "talk_duration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Average Talk Time",
      accessor: "avg_talktime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: " Total Idle Time",
      accessor: "idealtime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Break Time",
      accessor: "breaktime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Net Login Time",
      accessor: "netlogintime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ACW Time",
      accessor: "acwtime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Login Time",
      accessor: "logintime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Unservice Time",
      accessor: "unservicetime",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "10 Second",
      accessor: "second10",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "20 Second",
      accessor: "second20",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "30 Second",
      accessor: "second30",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "40 Second",
      accessor: "second40",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "50 Second",
      accessor: "second50",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "60 Second",
      accessor: "second60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
  ];
};

export { getFilterColumns };
